export const Logo = ({ onClick, className = "h-14 sm:h-16" }) => (
  <a href="#top" onClick={onClick} data-testid="nav-logo" className="flex items-center group shrink-0">
    <img src="/logo.png" alt="Nexora Events & Celebrations" className={`${className} w-auto transition-transform duration-500 group-hover:scale-[1.04]`} />
  </a>
);
